'use client';
import { createPreset } from "../createPreset.js";
import { caption1ClassNames, useCaption1Styles } from "./useCaption1Styles.styles.js";
/**
 * Text preset component for the Caption1 typography variant
 */ export const Caption1 = createPreset({
    useStyles: useCaption1Styles,
    className: caption1ClassNames.root,
    displayName: 'Caption1'
});
